import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loginModalOpen: false,
  registerModalOpen: false,
};

export const ModalSlice = createSlice({
  name: "modal",
  initialState: initialState,
  reducers: {
    setLoginModalOpen(state, action) {
      state.loginModalOpen = action.payload;
    },
    setRegisterModalOpen(state, action) {
      state.registerModalOpen = action.payload;
    },
  },
});

export const { setLoginModalOpen, setRegisterModalOpen } = ModalSlice.actions;
export default ModalSlice.reducer;
